/* eslint-disable */
import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Checkbox,
  FormControl,
  Grid,
  Paper,
  Typography,
  Link as MuiLink,
  FormControlLabel,
  FormGroup,
  Autocomplete,
} from '@mui/material';
import { AuthContext } from '../../contexts/authContext';
import { useValidEmail } from '../../hooks/useValidEmail';
import { useValidName } from '../../hooks/useValidName';
import {
  forgotHeaderStyle,
  inputStyle,
  labelStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
} from '../styles';
import { InputAdornment, TextField } from '@mui/material';
import { AuthPAGES } from '../../constants/pages';
import { agreedTermsStyle } from './styles';
import { Header } from '../../components/Header/Header';
import { MuiButton } from '../../components/Button/Button';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { Notif } from '../../components/Snackbar/Snackbar';
import { useValidPhone } from '../../hooks/useValidPhone';
import { States } from 'src/florence/constants/States';

const stateOptions = Object.values(States).map((state) => {
  return {
    label: state,
  };
});

const SignUp: React.FunctionComponent = () => {
  /* States and context declaration */
  const { name, setName, nameIsValid } = useValidName(null);
  const { email, setEmail, emailIsValid } = useValidEmail(null);
  const { phone, setPhone, phoneIsValid } = useValidPhone(null);
  const [state, setState] = useState<{ label: string } | null>(null);

  const [open, setOpen] = React.useState(false);
  const [acceptedToS, setAcceptedToS] = React.useState(false);
  const authContext = useContext(AuthContext);

  const navigate = useNavigate();

  /* Generic Error Message */
  const [genericErrorMessage, setGenericErrorMessage] = useState('');

  const validateEmail = async (email: string) => {
    try {
      await authContext.signInWithEmail(email, 'MyTesingPass%^945', null);
      return false;
    } catch (error: any) {
      console.log(error.code);
      if (
        error.code === 'UserNotFoundException' ||
        error.code === 'NotAuthorizedException'
      ) {
        return true;
      } else {
        setGenericErrorMessage('User with such email already exists');
        setOpen(true);
        return false;
      }
    }
  };

  const onNextClicked = async (e: any) => {
    e.stopPropagation();
    if (phone && name && email && state?.label) {
      authContext.setPhone(phone);
      authContext.setName(name);
      authContext.setEmail(email);
      authContext.setStateLocation(state.label);
      navigate(`${AuthPAGES.eula}`);
    }
  };

  const isButtonDisabled = () => {
    return (
      !acceptedToS ||
      !email ||
      !name ||
      !phone ||
      nameIsValid !== '' ||
      emailIsValid !== '' ||
      phoneIsValid !== '' ||
      !state
    );
  };

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <Grid item xl={4} lg={4} md={6} sm={10} xs={11}>
        <Paper
          elevation={1}
          style={paperStyle}
          className='responsive-paper-style'
        >
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <Header text1='Sign Up' text2='Create your account' />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <TextField
              id='outlined-adornment-email'
              size='small'
              style={{
                ...inputStyle,
                marginBottom: emailIsValid !== '' ? '24px' : '',
              }}
              type='text'
              fullWidth
              value={email ?? ''}
              error={emailIsValid !== ''}
              helperText={emailIsValid !== '' ? 'Check your email' : ''}
              onChange={(e: any) => setEmail(e.target.value)}
              label='E-mail *'
              InputProps={{
                style: { borderRadius: '50px' },
                startAdornment: (
                  <InputAdornment position='start'>
                    <EmailOutlinedIcon
                      style={{ color: '#227BEF', width: '20px' }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <TextField
              id='outlined-adornment-email'
              size='small'
              style={{
                ...inputStyle,
                marginBottom: nameIsValid !== '' ? '24px' : '',
              }}
              type='text'
              fullWidth
              value={name ?? ''}
              error={nameIsValid !== ''}
              helperText={nameIsValid !== '' ? 'Please check your name' : ''}
              onChange={(e: any) => setName(e.target.value)}
              label='Full Name *'
              inputProps={{ maxLength: 30 }}
              InputProps={{
                style: { borderRadius: '50px' },
                startAdornment: (
                  <InputAdornment position='start'>
                    <PersonOutlineOutlinedIcon
                      style={{ color: '#227BEF', width: '20px' }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <TextField
              id='outlined-adornment-email'
              size='small'
              style={{
                ...inputStyle,
                marginBottom: phoneIsValid !== '' ? '24px' : '',
              }}
              type='text'
              fullWidth
              value={phone ?? ''}
              error={phoneIsValid != ''}
              helperText={phoneIsValid}
              onChange={(e: any) => {
                const re = /^[0-9\b]+$/;
                setPhone('');
                if (e.target.value === '' || re.test(e.target.value)) {
                  setPhone(e.target.value);
                }
              }}
              label='Phone Number *'
              InputProps={{
                style: { borderRadius: '50px' },
                startAdornment: (
                  <InputAdornment position='start'>
                    <LocalPhoneOutlinedIcon
                      style={{ color: '#227BEF', width: '20px' }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <Autocomplete
              disablePortal
              size='small'
              fullWidth
              value={state}
              onChange={(e, value) => setState(value)}
              options={stateOptions}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  style={inputStyle}
                  size='small'
                  label='State *'
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: '50px' },
                    startAdornment: (
                      <InputAdornment
                        position='start'
                        style={{
                          display: 'flex',
                        }}
                      >
                        <LocationOnOutlinedIcon
                          style={{
                            color: '#227BEF',
                            width: 20,
                            marginLeft: 6,
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={{ marginTop: '32px' }}>
            <MuiButton
              loading={false}
              disabled={isButtonDisabled()}
              text='Continue'
              onSubmit={onNextClicked}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ marginTop: '16px', alignSelf: 'center' }}
          >
            <FormGroup>
              <FormControl required>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => setAcceptedToS(e.target.checked)}
                    />
                  }
                  label={
                    <Typography textAlign='center'>
                      I agree with our{' '}
                      <MuiLink
                        target='_blank'
                        rel='noopener'
                        href='https://www.galeai.co/eula'
                        style={agreedTermsStyle}
                      >
                        Terms of Service
                      </MuiLink>{' '}
                      and{' '}
                      <MuiLink
                        target='_blank'
                        rel='noopener'
                        href='https://www.galeai.co/privacy-policy-page'
                        style={agreedTermsStyle}
                      >
                        Privacy Policy
                      </MuiLink>
                    </Typography>
                  }
                />
              </FormControl>
            </FormGroup>
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={labelStyle}>
            <Typography style={pLabelDarkerStyle}>
              Have an account?
              <br />
              <Link
                to={AuthPAGES.signIn}
                style={{ ...pLabelStyle, marginLeft: '5px' }}
              >
                Sign in
              </Link>
            </Typography>
          </Grid>
        </Paper>
      </Grid>
      <Notif open={open} setOpen={setOpen} message={genericErrorMessage} />
    </Grid>
  );
};

export default SignUp;
